import {useEffect} from "react";
import {usePublicEndpoints} from "../../api/usePublicEndpoints";

export const getDataOrder = (order, setOrder, stopField) => {
    const {getOrder} = usePublicEndpoints()

    useEffect (() => {
        let timeout

        if (order?.id) {
            const shortPolling = () => {
                getOrder(order?.id)
                    .then(res => {
                        setOrder(res)
                        if(!res?.[stopField]) {
                            timeout = setTimeout(shortPolling, 2000);
                        }
                    })
                    .catch(() => {
                        timeout = setTimeout(shortPolling, 2000);
                    })
            }

            shortPolling()

            return () => clearTimeout(timeout);
        }
    }, [order?.id])
}